// extracted by mini-css-extract-plugin
export default {"root":"SharedTabs__root--1t7uC"};